"use client";

import { c as _c } from "react/compiler-runtime";
import { CButton } from "@coreui/react";
import { forwardRef, type ButtonHTMLAttributes } from "react";
type Variant = "solid" | "outline" | "ghost" | "link" | "subtle";
type Size = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
export type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size"> & {
  variant?: Variant;
  size?: Size;
};
function mapVariant(variant: Variant | undefined): "outline" | "ghost" | undefined {
  if (variant === "outline") return "outline";
  if (variant === "ghost" || variant === "link" || variant === "subtle") return "ghost";
  return undefined;
}
function mapSize(size: Size | undefined): "sm" | "lg" | undefined {
  if (size === "xs" || size === "sm") return "sm";
  if (size === "lg" || size === "xl" || size === "2xl") return "lg";
  return undefined;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(t0, ref) {
  const $ = _c(18);
  let className;
  let rest;
  let size;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      type: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = size;
    $[4] = t1;
    $[5] = variant;
  } else {
    className = $[1];
    rest = $[2];
    size = $[3];
    t1 = $[4];
    variant = $[5];
  }
  const type = t1 === undefined ? "button" : t1;
  const t2 = variant === "subtle" ? "secondary" : "primary";
  let t3;
  if ($[6] !== variant) {
    t3 = mapVariant(variant);
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== size) {
    t4 = mapSize(size);
    $[8] = size;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== className || $[11] !== ref || $[12] !== rest || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== type) {
    t5 = <CButton ref={ref} type={type} color={t2} variant={t3} size={t4} className={className} {...rest} />;
    $[10] = className;
    $[11] = ref;
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = type;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
});